<!-- 添加队员弹窗 -->
<template>
  <a-modal
    title="添加队员"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :destroyOnClose="true"
    okText="提交"
    cancelText="取消"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item label="上传头像" :label-col="labelCol" :wrapper-col="wrapperCol">
        <Upload ref="upload" @uploadSuccess="uploadSuccess" :fixedNumber="[5, 7]"></Upload>
      </a-form-item>
      <a-form-item label="选择国籍" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="organisersId !== 1">
        <a-select
          placeholder="请选择国籍"
          @change="nationalityChange"
          v-decorator="['nationality',{ rules: [{ required: true, message: '请选择国籍' }], initialValue: params.nationality }]">
          <a-select-option :value="item.name" v-for="item in nationality" :key="item.name">{{item.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="人员类别" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="organisersId === 1">
        <a-select
          placeholder="请选择人员类别"
          @change="playerTypeChange"
          v-decorator="['playerType',{ rules: [{ required: true, message: '请选择人员类别' }], initialValue: params.type }]">
          <a-select-option :value="item.id" v-for="item in PlayerType" :key="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="输入姓名" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input
          placeholder="请输入姓名"
          v-decorator="['name',{ rules: [{ required: true, message: '请输入姓名' }] }]" />
      </a-form-item>
      <a-form-item label="身份证号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="params.nationality === '中国大陆'">
        <a-input
          placeholder="请输入身份证号码"
          v-decorator="['idCard',{ rules: [{ required: true, message: '请输入身份证号码' }] }]" />
      </a-form-item>
      <a-form-item label="护照号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="params.nationality !== '中国大陆'">
        <a-input
          placeholder="请输入护照号"
          v-decorator="['passport',{ rules: [{ required: true, message: '请输入护照号' }] }]" />
      </a-form-item>
      <a-form-item label="性别" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="params.nationality !== '中国大陆'">
        <a-select
          placeholder="请选择性别"
          v-decorator="['sex',{ rules: [{ required: true, message: '请选择性别' }] }]">
          <a-select-option value="1" :key="1">男</a-select-option>
          <a-select-option value="2" :key="2">女</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="出生日期" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="params.nationality !== '中国大陆'">
        <a-date-picker
          :allowClear="false"
          placeholder="请选择出生日期"
          @change="birthdayChange"
          v-decorator="['birthday',{ rules: [{ required: true, message: '请选择出生日期' }] }]"
        />
      </a-form-item>
      <a-form-item label="球衣号" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input-number
          placeholder="请输入球衣号"
          :min="0"
          :max="100"
          style="width: 100%;"
          v-decorator="['shirtNumber',{ rules: [{ required: true, message: '请输入球衣号' }] }]" />
      </a-form-item>
      <a-form-item label="场上位置" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="locationList.length > 0">
        <a-select
          placeholder="请选择位置"
          v-decorator="['location',{ rules: [{ required: true, message: '请选择位置' }] }]">
          <a-select-option v-for="item in locationList" :value="item.title" :key="item.title">{{ item.title }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import Upload from '@comm/upload/Upload'
import nationality from '@comm/utils/nationalityUtil'
import PlayerType from '@comm/config/high-tech/PlayerType'
import { checkIdCard, getBirthday, getSex } from '@comm/utils/IdCardUtils'
import store from '@/store'
export default {
  components: {
    Upload
  },
  data () {
    return {
      nationality,
      PlayerType,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      locationList: [],
      matchInfo: store.getters['match/matchInfo'],
      organisersId: JSON.parse(localStorage.getItem('matchInfo')).agencyId, // 赛事主办方id, 如果是高新区的赛事，在添加队员的时候不选择国籍,需要选择人员类别（在职在编人员、文员、聘用人员）
      params: {
        agencyId: this.$route.query.agencyId,
        matchId: this.$route.query.matchId,
        birthday: null,
        card: null,
        customerId: JSON.parse(localStorage.getItem('userInfo')).id,
        image: null,
        name: null,
        nationality: '中国大陆',
        sex: null,
        teamId: null,
        jerseyNumber: null,
        location: '待定',
        type: JSON.parse(localStorage.getItem('matchInfo')).agencyId === 1 ? 3 : 0
      }
    }
  },
  methods: {
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 是否必须上传队员头像
          if (!this.params.image && !this.matchInfo.imageIsRequired.player) {
            // 如果不是必传项，则添加一个默认头像
            this.params.image = 'https://static.daoba.com//838779651131.jpg'
          }
          if (this.params.image == null) {
            this.$message.error('请上传队员头像')
            return
          }
          let teamId = localStorage.getItem('teamId')
          if (teamId == null) {
            this.$message.error('请先选择一个参赛队伍')
            return
          }
          this.params.teamId = teamId
          if (this.params.nationality === '中国大陆') {
            // 解析身份证获取生日和性别
            let idCard = values['idCard']
            this.params.card = idCard
            if (checkIdCard(idCard)) {
              this.params.birthday = getBirthday(idCard)
              this.params.sex = getSex(idCard)
            } else {
              this.$message.error('身份证输入错误')
              return
            }
          } else {
            this.params.card = values['passport']
            this.params.sex = values['sex']
          }
          this.params.name = values['name']
          this.params.jerseyNumber = values['shirtNumber']
          if (this.locationList.length > 0) {
            this.params.location = values['location']
          }
          this.postData()
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.params = {
        agencyId: this.$route.query.agencyId,
        matchId: this.$route.query.matchId,
        birthday: null,
        card: null,
        customerId: JSON.parse(localStorage.getItem('userInfo')).id,
        image: null,
        name: null,
        nationality: '中国大陆',
        sex: null,
        teamId: null,
        jerseyNumber: null,
        location: '待定',
        type: JSON.parse(localStorage.getItem('matchInfo')).agencyId === 1 ? 3 : 0
      }
    },
    show () {
      this.visible = true
      this.initLocationList()
    },
    nationalityChange (value) {
      this.params.nationality = value
    },
    playerTypeChange (value) {
      this.params.type = value
    },
    birthdayChange (e, str) {
      this.params.birthday = str
    },
    uploadSuccess (fileList) {
      if (fileList.length > 0) {
        this.params.image = fileList[0].url
      } else {
        this.params.image = null
      }
    },
    postData () {
      this.confirmLoading = true
      this.$api.join.addBigballPlayer(this.params).then(res => {
        if (res.status === 0) {
          this.$message.success('添加成功')
          this.$emit('success')
          this.handleCancel()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('添加失败')
      }).finally(_ => {
        this.confirmLoading = false
      })
    },
    initLocationList () {
      if (this.$route.query.programId === 4) {
        this.locationList = [{title: '中锋'}, {title: '左中峰'}, {title: '左边锋'}, {title: '右中锋'}, {title: '右边锋'}, {title: '中前锋'}, {title: '左前锋'}, {title: '右前锋'},
          {title: '前腰'}, {title: '左前腰'}, {title: '右前腰'}, {title: '中中场'}, {title: '左中中场'}, {title: '左中场'}, {title: '左边中场'}, {title: '右中中场'}, {title: '右中场'},
          {title: '右边中场'}, {title: '后腰'}, {title: '左后腰'}, {title: '右后腰'}, {title: '中后卫'}, {title: '左中后卫'}, {title: '左后卫'}, {title: '左边后卫'}, {title: '右中后卫'},
          {title: '右后卫'}, {title: '右边后卫'}, {title: '清道夫'}, {title: '守门员'}]
      } else if (this.$route.query.programId === 5) {
        this.locationList = [
          {title: '控球后卫'}, {title: '得分后卫'}, {title: '小前锋'}, {title: '大前锋'}, {title: '中锋'}
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/player/AddBigballPlayer.vue